// Mock data for RADIX — Beauty & Skincare gadgets store
// NOTE: This is MOCK data used for the frontend-only teaser version.

export const categories = [
  { id: "rosto", name: "Rosto", slug: "rosto", tagline: "Dispositivos faciais", image: "https://images.unsplash.com/photo-1710839006592-4fdfc6caca80?w=800&q=80" },
  { id: "cabelo", name: "Cabelo", slug: "cabelo", tagline: "Styling inteligente", image: "https://images.unsplash.com/photo-1581182800629-7d90925ad072?w=800&q=80" },
  { id: "corpo", name: "Corpo", slug: "corpo", tagline: "Recuperação & massagem", image: "https://images.unsplash.com/photo-1643684391140-c5056cfd3436?w=800&q=80" },
  { id: "acessorios", name: "Acessórios", slug: "acessorios", tagline: "Complementos essenciais", image: "https://images.unsplash.com/photo-1592136957897-b2b6ca21e10d?w=800&q=80" },
];

export const brands = ["RADIX Pro", "GlowLab", "DermaTech", "AuraSkin", "PureWave", "LumiCare"];

export const products = [
  {
    id: "led-mask-pro",
    name: "Máscara LED Facial Pro",
    brand: "RADIX Pro",
    category: "rosto",
    subtitle: "7 cores de terapia de luz",
    price: 79.99,
    oldPrice: 129.99,
    rating: 4.8,
    reviews: 1243,
    badge: "BESTSELLER",
    isNew: false,
    images: [
      "https://images.unsplash.com/photo-1710839422734-de9f105bfce0?w=900&q=80",
      "https://images.unsplash.com/photo-1710839290079-62ee20333f6b?w=900&q=80",
    ],
    shortDesc: "Terapia de luz LED de nível clínico para casa. Reduz manchas, acne e sinais de idade.",
    description:
      "A Máscara LED Facial Pro traz o poder da fototerapia profissional para a sua rotina diária. Com 7 comprimentos de onda de luz (vermelha, azul, verde e mais), estimula colagénio, combate a acne e uniformiza o tom da pele em sessões de apenas 10 minutos.",
    features: ["7 cores de luz LED", "Sessões de 10 min", "Sem fios, recarregável USB-C", "Silicone flexível suave", "Resultados visíveis em 4 semanas"],
    stock: 34,
  },
  {
    id: "microcurrent-lift",
    name: "Dispositivo de Microcorrente Lift",
    brand: "DermaTech",
    category: "rosto",
    subtitle: "Lifting facial sem cirurgia",
    price: 59.99,
    oldPrice: 99.99,
    rating: 4.7,
    reviews: 876,
    badge: "-40%",
    isNew: false,
    images: [
      "https://images.unsplash.com/photo-1710839290079-62ee20333f6b?w=900&q=80",
      "https://images.unsplash.com/photo-1712482937664-5697b56ed6f1?w=900&q=80",
    ],
    shortDesc: "Tonifica e define os contornos do rosto com microcorrentes suaves.",
    description:
      "Inspirado nos tratamentos de spa de luxo, este dispositivo de microcorrente estimula os músculos faciais para um efeito lifting natural. Uso diário de 5 minutos para um rosto mais firme e definido.",
    features: ["Microcorrente ajustável", "Efeito lifting imediato", "Recarregável", "Inclui gel condutor", "Ideal para linha da mandíbula"],
    stock: 21,
  },
  {
    id: "ionic-brush",
    name: "Escova Alisadora Iónica 2-em-1",
    brand: "GlowLab",
    category: "cabelo",
    subtitle: "Cabelo de salão em 5 minutos",
    price: 44.99,
    oldPrice: 69.99,
    rating: 4.6,
    reviews: 2011,
    badge: "BESTSELLER",
    isNew: false,
    images: [
      "https://images.unsplash.com/photo-1581182800629-7d90925ad072?w=900&q=80",
      "https://images.unsplash.com/photo-1583209814683-c023dd293cc6?w=900&q=80",
    ],
    shortDesc: "Alisa e dá volume ao mesmo tempo com tecnologia iónica anti-frizz.",
    description:
      "A escova alisadora iónica combina calor cerâmico com iões negativos para eliminar o frizz e deixar o cabelo brilhante e sedoso. Aquecimento rápido e 5 níveis de temperatura para todos os tipos de cabelo.",
    features: ["Tecnologia iónica anti-frizz", "Placas de cerâmica", "5 níveis de temperatura", "Aquece em 30 seg", "Desligar automático"],
    stock: 48,
  },
  {
    id: "vacuum-cleaner",
    name: "Removedor de Pontos Negros a Vácuo",
    brand: "PureWave",
    category: "rosto",
    subtitle: "Limpeza profunda dos poros",
    price: 29.99,
    oldPrice: 49.99,
    rating: 4.5,
    reviews: 1567,
    badge: "-40%",
    isNew: false,
    images: [
      "https://images.unsplash.com/photo-1702261952318-241e4594b2f5?w=900&q=80",
      "https://images.unsplash.com/photo-1710839006592-4fdfc6caca80?w=900&q=80",
    ],
    shortDesc: "Sucção a vácuo que remove impurezas e desobstrui os poros.",
    description:
      "Diga adeus aos pontos negros com este dispositivo de sucção a vácuo. Com 3 níveis de intensidade e 4 cabeças intercambiáveis, remove impurezas e cravos de forma segura e eficaz.",
    features: ["3 níveis de sucção", "4 cabeças intercambiáveis", "Recarregável USB", "Ecrã LED", "Adequado a todos os tipos de pele"],
    stock: 62,
  },
  {
    id: "massage-gun",
    name: "Pistola de Massagem Compacta",
    brand: "RADIX Pro",
    category: "corpo",
    subtitle: "Recuperação muscular profunda",
    price: 49.99,
    oldPrice: 89.99,
    rating: 4.8,
    reviews: 934,
    badge: "NOVO",
    isNew: true,
    images: [
      "https://images.unsplash.com/photo-1643684391140-c5056cfd3436?w=900&q=80",
      "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?w=900&q=80",
    ],
    shortDesc: "Alívio de tensões e dores musculares em qualquer lugar.",
    description:
      "Compacta mas poderosa, esta pistola de massagem oferece percussão profunda para relaxar músculos, aliviar dores e acelerar a recuperação pós-treino. 30 velocidades e 6 cabeças diferentes.",
    features: ["30 velocidades", "6 cabeças de massagem", "Bateria 6h de duração", "Ultra silenciosa", "Bolsa de transporte incluída"],
    stock: 27,
  },
  {
    id: "gua-sha-set",
    name: "Kit Gua Sha & Rolo de Jade",
    brand: "AuraSkin",
    category: "acessorios",
    subtitle: "Ritual de beleza tradicional",
    price: 19.99,
    oldPrice: 34.99,
    rating: 4.7,
    reviews: 3120,
    badge: "-43%",
    isNew: false,
    images: [
      "https://images.unsplash.com/photo-1592136957897-b2b6ca21e10d?w=900&q=80",
      "https://images.unsplash.com/photo-1739980104488-408eff709fff?w=900&q=80",
    ],
    shortDesc: "Massaja, drena e revitaliza a pele com pedra natural.",
    description:
      "Este kit de Gua Sha e rolo de jade em quartzo natural ajuda a reduzir o inchaço, drenar toxinas e melhorar a absorção dos seus produtos de skincare. Um ritual relaxante para uma pele radiante.",
    features: ["Quartzo natural", "Reduz inchaço", "Melhora circulação", "Inclui estojo", "Presente perfeito"],
    stock: 88,
  },
  {
    id: "cleansing-brush",
    name: "Escova de Limpeza Facial Sónica",
    brand: "LumiCare",
    category: "rosto",
    subtitle: "Limpeza 6x mais profunda",
    price: 34.99,
    oldPrice: 54.99,
    rating: 4.6,
    reviews: 742,
    badge: "NOVO",
    isNew: true,
    images: [
      "https://images.unsplash.com/photo-1712482937676-398342a92e81?w=900&q=80",
      "https://images.unsplash.com/photo-1702261952387-e35f3dc5d0c3?w=900&q=80",
    ],
    shortDesc: "Silicone antibacteriano com vibração sónica suave.",
    description:
      "A escova de limpeza sónica remove maquilhagem, óleo e impurezas com vibrações suaves. O silicone antibacteriano é delicado com a pele e higiénico, ideal para uso diário.",
    features: ["Vibração sónica", "Silicone antibacteriano", "À prova de água IPX7", "3 modos de limpeza", "Recarga sem fios"],
    stock: 55,
  },
  {
    id: "hair-dryer-ionic",
    name: "Secador Iónico Profissional",
    brand: "GlowLab",
    category: "cabelo",
    subtitle: "Secagem rápida sem danos",
    price: 64.99,
    oldPrice: 109.99,
    rating: 4.9,
    reviews: 1289,
    badge: "BESTSELLER",
    isNew: false,
    images: [
      "https://images.unsplash.com/photo-1583209814683-c023dd293cc6?w=900&q=80",
      "https://images.unsplash.com/photo-1581182800629-7d90925ad072?w=900&q=80",
    ],
    shortDesc: "Motor de alta velocidade com tecnologia iónica e controlo de calor.",
    description:
      "Seque o cabelo em metade do tempo com este secador iónico de motor digital. Reduz o frizz, protege do calor e deixa o cabelo brilhante. Inclui difusor e concentrador.",
    features: ["Motor digital de alta velocidade", "Tecnologia iónica", "Controlo inteligente de calor", "Difusor + concentrador", "Leve e ergonómico"],
    stock: 19,
  },
];

export const testimonials = [
  { id: 1, name: "Sofia M.", location: "Lisboa", rating: 5, text: "A máscara LED mudou a minha pele em 3 semanas! Nunca mais largo.", product: "Máscara LED Facial Pro" },
  { id: 2, name: "Beatriz C.", location: "Porto", rating: 5, text: "A escova alisadora é incrível, cabelo de salão em minutos.", product: "Escova Alisadora Iónica" },
  { id: 3, name: "Ana R.", location: "Braga", rating: 4, text: "O dispositivo de microcorrente deixa o rosto muito mais firme. Recomendo!", product: "Dispositivo de Microcorrente" },
];

export const benefits = [
  { icon: "Truck", title: "Envio grátis", desc: "Em compras acima de 35€" },
  { icon: "ShieldCheck", title: "Garantia 2 anos", desc: "Em todos os dispositivos" },
  { icon: "RotateCcw", title: "30 dias devolução", desc: "Sem complicações" },
  { icon: "Headphones", title: "Apoio dedicado", desc: "Especialistas em beleza" },
];

export const heroSlides = [
  {
    id: 1,
    title: "Skincare de clínica, em casa",
    subtitle: "Máscara LED Facial Pro — resultados profissionais em 10 minutos",
    cta: "Comprar agora",
    link: "/produto/led-mask-pro",
    image: "https://images.unsplash.com/photo-1710839422734-de9f105bfce0?w=1600&q=80",
    align: "left",
  },
  {
    id: 2,
    title: "O teu ritual de beleza reinventado",
    subtitle: "Dispositivos inteligentes que elevam a tua pele todos os dias",
    cta: "Ver coleção",
    link: "/loja",
    image: "https://images.unsplash.com/photo-1710839006592-4fdfc6caca80?w=1600&q=80",
    align: "left",
  },
];
